import { Entity } from "src/app/core/utils/entity";

export abstract class UserData extends Entity {
    constructor(
        public id: string,
        public rol: string,
        public name: string,
        public lastName: string,
        public cuil: string,
        public gender: string,
        public phone: string,
        public birthDate: Date,
        public civilStatus: string,
        public province: string,
        public city: string,
        public street: string,
        public number: string,
        public floorApartment: string,
        public postalCode: number,
        public company: string,
        public companyCuil: string,
        public email: string,
        public dni: string,
        public neighborhood: string,
        public tower?: string,
        public claims?: string[],
        public razon_social?: string,
        public tipo_actuacion?: string,
        public cargo_empresa?: string,
        public company_cuit?: string,
        public phone_company?: string,
        public type_responsibility?: string,
    ) {
        super();
    }
}
